var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7042 0.0195312H4.7958L8.75 4.87607L12.7042 0.0195312ZM17 5.17578L13.5389 0.622168L9.83281 5.17578H17ZM3.96113 0.621201L0.5 5.17578H7.66719L3.96113 0.621201ZM8.37295 14.2927C8.46963 14.399 8.6082 14.457 8.75 14.457C8.8918 14.457 9.02886 14.3981 9.12608 14.2939L16.9549 6.20703H0.543989L8.37295 14.2927Z",
    fill: "#8DC63F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium);
export default __webpack_public_path__ + "static/media/premium.d4a47d047de11359086b89a444495104.svg";
export { ForwardRef as ReactComponent };